import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  borderRadius,
  breakpoint,
  duration,
  easing,
  fontSize,
  size,
} from '@twistopayments/design-system/styles'

export const carousel = css`
  position: relative;
  width: 100%;
  margin: auto;
  overflow: hidden;
`

export const carouselInner = css`
  display: flex;
  transition: transform ${duration.gentle}ms ${easing.easeInOut};
`

export const carouselControl = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  bottom: auto;
  left: auto;
  right: auto;
  width: ${size[48]};
  height: ${size[48]};
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.2);
  color: ${theme.palette.background.main};
  border: none;
  font-size: ${fontSize.xxs};
  font-weight: 400;
  cursor: pointer;
  border-radius: ${borderRadius.circle};
  user-select: none;
  z-index: 1;

  ${breakpoint.down(96)} {
    transform: none;
    bottom: ${size[40]};
    top: auto;
  }
`

export const prevButton = css`
  left: ${size[96]};

  ${breakpoint.down(106)} {
    left: ${size[24]};
    right: auto;
  }

  ${breakpoint.down(96)} {
    right: ${size[80]};
    left: auto;
  }
`

export const nextButton = css`
  right: ${size[96]};

  ${breakpoint.down(106)} {
    right: ${size[24]};
    left: auto;
  }

  ${breakpoint.down(96)} {
    right: ${size[20]};
    left: auto;
  }
`

export const indicators = css`
  position: absolute;
  top: auto;
  bottom: ${size[36]};
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: ${size[16]};

  ${breakpoint.down(75)} {
    top: auto;
    left: ${size[28]};
    right: auto;
    bottom: ${size[56]};
    transform: none;
  }
`

export const indicator =
  (isStaticTransparent: boolean) => (theme: Theme) => css`
    width: ${size[12]};
    height: ${size[12]};
    background-color: ${isStaticTransparent
      ? theme.palette.tertiary.mediumContrast
      : theme.palette.background.main};
    border: none;
    border-radius: ${borderRadius.circle};
    cursor: pointer;
    transition: background-color ${duration.standard}ms;
  `

export const activeIndicator = (theme: Theme) => css`
  background-color: ${theme.palette.secondary.mainContrast};
`
